import {useEffect, useState} from "react";

export default function useOrientation() {
    const getOrientation = () =>
        window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';

    const [orientation, setOrientation] = useState(getOrientation());

    useEffect(() => {
        const mediaQuery = window.matchMedia('(orientation: portrait)');
        const handler = (e) => setOrientation(e.matches ? 'portrait' : 'landscape');

        mediaQuery.addEventListener('change', handler);
        return () => mediaQuery.removeEventListener('change', handler);
    }, []);

    return orientation;
}
